import StudentStatisticsPage from "./StudentStatisticsPage";

export default StudentStatisticsPage